import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setCenters: Function
  setCustomers: Function
  setStates: Function
  setAllStates: Function
  setCountries: Function
  setCurrentCountry: Function
  setValue: Function
  currentCustomer: {} | null
  isSuperAdmin: boolean
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    const promises: Array<Promise<any>> = []

    let centers: Array<any> = []
    const centersRequest = getAll(apiUrls.centers, true).then((data) => (centers = data))
    promises.push(centersRequest)

    let customers: Array<any> = []
    if (props.isSuperAdmin) {
      const customersRequest = getAll(apiUrls.customers).then((data) => (customers = data))
      promises.push(customersRequest)
    }

    let states: Array<any> = []
    const statesRequest = getAll(apiUrls.states).then((data) => (states = data))
    promises.push(statesRequest)

    let countries: Array<any> = []
    const countriesRequest = getAll(apiUrls.countries).then((data) => (countries = data))
    promises.push(countriesRequest)

    Promise.all(promises).then(() => {
      props.setCenters(centers)
      if (props.isSuperAdmin) {
        props.setCustomers(customers)
      }
      props.setStates(states)
      props.setAllStates(states)
      props.setCountries(countries)
      if (props.id !== undefined) {
        loadRecord(apiUrls.users, props.id).then((data) => {
          props.setCurrentCountry(data.country_id)
          props.reset(data)
          props.setValue('state', data.state ?? null)
          props.setDataLoaded(true)
          props.setShowOverlay(false)
          if (props.isSuperAdmin) {
            data.customers.forEach((c) => {
              const selectedCenters = data.centers.filter((ce) => ce.customer_id === c.id)
              props.setValue('centersbycustomer' + c.id, selectedCenters)
            })
          }
        })
      } else {
        //reset centers and customers when customer changed
        props.setValue('centers', [])
        props.setValue('customers', [])
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      }
    })
  }, [props.currentCustomer])
}

export default useInit
